import Axios from "axios";

export default function api(endpoint, body, customData = {}, headers = {}) {
  return Axios({
    url: `https://adminpanel.german-gold.de/api/${endpoint}`,
    method: body ? "POST" : "GET",
    data: body,
    headers: {
      ...headers,
    },
    ...customData,
  });
}
